import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

export function useUserRole() {
	const page = usePage();

	const isAdmin = computed(() =>
		page.props.auth?.user?.roles.includes('system_admin'),
	);
	const isClient = computed(() =>
		page.props.auth?.user?.roles.includes('client_admin'),
	);
	const isVendor = computed(() =>
		page.props.auth?.user?.roles.includes('vendor_admin'),
	);
	const isTalent = computed(() =>
		page.props.auth?.user?.roles.includes('vendor_resource_talent'),
	);
	const isGuest = computed(() => !page.props.auth?.user);

	function hasPermission(permission: string): boolean {
		return page.props.auth?.user?.permissions?.includes(permission) ?? false;
	}

	return {
		isAdmin,
		isClient,
		isVendor,
		isGuest,
		isTalent,
		hasPermission,
	};
}
